// extracted by mini-css-extract-plugin
module.exports = {"emptyCard":"empty-card_emptyCard__51qA8","text":"empty-card_text__35pgX"};